import React from 'react';
import { SalesPage } from './components/SalesPage';
import './index.css';
export function App() {
  return <SalesPage data-id="element-0" />;
}